module.exports = __webpack_public_path__ + "img/s00156.03046760.jpg";